import React, { useEffect, useState } from 'react'
import ProtectedRoute from '../../routes/protected'
import SidebarCargosSalarios from '../../components/sidebars/sidebarCargosSalarios'
import salaryAnalysisService from '../../services/data/salary-analysis.service'
import companyService from '../../services/data/company.service'
import currencyFormat from '../../helpers/currencyFormat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Dropdown } from 'primereact/dropdown'

export default function CompararEstruturas() {
    const [structures, setStructures] = useState([null, null])
    const [structureItems, setStructureItems] = useState([])
    const [result, setResult] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        companyService.autoCompletePayStructure('')
            .then(r => setStructureItems(r || []))
            .catch(() => setStructureItems([]))
    }, [])

    function setStructureSel(idx, val) {
        const updated = [...structures]
        updated[idx] = val
        setStructures(updated)
    }

    function addSlot() {
        if (structures.length >= 3) return
        setStructures([...structures, null])
    }

    function compare() {
        const ids = structures.filter(Boolean).map(s => s.id)
        if (ids.length < 2) { setError('Selecione ao menos 2 estruturas para comparar.'); return }
        setError(''); setLoading(true)
        salaryAnalysisService.compararEstruturas(ids)
            .then(setResult)
            .catch(e => setError(JSON.stringify(e?.response?.data || e)))
            .finally(() => setLoading(false))
    }

    // Montar tabela comparativa
    const gradeSet = []
    result.forEach(s => {
        s.grades.forEach(g => {
            if (!gradeSet.find(x => x.title === g.grade_title)) {
                gradeSet.push({ title: g.grade_title, levels: g.levels.map(l => l.level_title) })
            }
        })
    })

    return (
        <ProtectedRoute>
            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <SidebarCargosSalarios />
                    <div className="col-xs-10 col-sm-9 col-md-9 col-xl-10 p-0 formMarginBottom">
                        <div className='col text-bg-green p-3'>
                            <span className="fs-6 fw-bold">Comparativo de Estruturas Salariais</span>
                        </div>

                        <div className='row m-3 g-3 align-items-end'>
                            {structures.map((sel, idx) => (
                                <div key={idx} className='col-md-3'>
                                    <label className='form-label small fw-bold'>Estrutura {idx + 1}</label>
                                    <Dropdown className='w-100' placeholder={`Estrutura ${idx + 1}`}
                                        value={sel}
                                        options={structureItems}
                                        optionLabel='title'
                                        filter
                                        showClear
                                        onChange={e => setStructureSel(idx, e.value)} />
                                </div>
                            ))}
                            {structures.length < 3 && (
                                <div className='col-auto'>
                                    <button className='btn btn-outline-success btn-sm' onClick={addSlot}>
                                        <FontAwesomeIcon icon={solid('plus')} /> Add estrutura
                                    </button>
                                </div>
                            )}
                            <div className='col-auto'>
                                <button className='btn btn-success btn-sm' onClick={compare}>
                                    <FontAwesomeIcon icon={solid('scale-balanced')} /> Comparar
                                </button>
                            </div>
                        </div>

                        {error && <div className='alert alert-danger mx-3'>{error}</div>}

                        {loading && (
                            <div className='text-center p-5'>
                                <div className="spinner-border text-success" role="status" />
                            </div>
                        )}

                        {!loading && result.length >= 2 && (
                            <div className='m-3 table-responsive'>
                                <table className='table table-bordered table-sm'>
                                    <thead className='table-light'>
                                        <tr>
                                            <th>Grau</th>
                                            <th>Nível</th>
                                            {result.map((s, i) => (
                                                <th key={i} colSpan={3} className='text-center'>
                                                    {s.structure_title}
                                                    <div className='text-muted small fw-normal'>Mín / Mid / Máx</div>
                                                </th>
                                            ))}
                                            {result.length === 2 && <th className='text-center'>Δ% (Mid)</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {result[0].grades.map((grade, gi) =>
                                            grade.levels.map((level, li) => {
                                                const rows = result.map(s => {
                                                    const g = s.grades.find(g => g.grade_title === grade.grade_title)
                                                    return g ? g.levels.find(l => l.level_title === level.level_title) : null
                                                })
                                                const mid0 = rows[0]?.mid
                                                const mid1 = rows[1]?.mid
                                                const delta = (mid0 && mid1 && mid0 !== 0)
                                                    ? ((mid1 - mid0) / mid0 * 100).toFixed(1)
                                                    : null

                                                return (
                                                    <tr key={`${gi}-${li}`}>
                                                        {li === 0 && <td rowSpan={grade.levels.length} className='fw-bold align-middle'>{grade.grade_title}</td>}
                                                        <td>{level.level_title}</td>
                                                        {rows.map((row, ri) => (
                                                            <React.Fragment key={ri}>
                                                                <td className='text-end small'>{row?.min !== null ? currencyFormat(row.min) : '-'}</td>
                                                                <td className='text-end small fw-bold'>{row?.mid !== null ? currencyFormat(row.mid) : '-'}</td>
                                                                <td className='text-end small'>{row?.max !== null ? currencyFormat(row.max) : '-'}</td>
                                                            </React.Fragment>
                                                        ))}
                                                        {result.length === 2 && (
                                                            <td className={`text-center fw-bold ${delta > 0 ? 'text-success' : delta < 0 ? 'text-danger' : 'text-muted'}`}>
                                                                {delta !== null ? `${delta > 0 ? '+' : ''}${delta}%` : '-'}
                                                            </td>
                                                        )}
                                                    </tr>
                                                )
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}
